import { AppliedFilter } from "@organisms/ObjectsView/ObjectsView.types"

export type ListFiltersConfig = {
    filters: AppliedFilter[]
}

export type ListFiltersCompanyConfig = {
    tabs: {
        [key: string]: ListFiltersConfig | undefined
    }
}

export type ListFiltersConfigType = {
    version: string
    companies: {
        [companyId: number]: ListFiltersCompanyConfig | undefined
    }
}

const defaultListFiltersConfig: ListFiltersConfigType = {
    /*
        Versioning Scheme:
        - Major: Breaking changes to the applied-filter shape; the stored filters are dropped.
        - Minor: Changes the stored filters survive.
        Every tab starts with no filters, so there are no per-list defaults to seed.
    */
    version: "1.0.0",
    companies: {},
}

export default defaultListFiltersConfig
